import React from "react";
import styles from "./TermsAndConditions.module.css";

const CancellationRefundPolicy = () => {
  return (
    <div className={styles.termsContainer}>
      <h1 className={styles.title}>Sageion.com Cancellation and Refund Policy</h1>
      <p className={styles.subtitle}>
        Last Revised: October 13, 2025. Please read carefully.
      </p>

      {/* 1. Subscription Fees */}
      <section className={styles.section}>
        <h2 className={styles.sectionTitle}>1. Subscription Fees</h2>
        <p className={styles.text}>
          Certain features of Sageion.com require payment. All fees are listed on our website and are exclusive of applicable taxes, which are your responsibility.
        </p>
      </section>

      {/* 2. Free Trials */}
      <section className={styles.section}>
        <h2 className={styles.sectionTitle}>2. Free Trials</h2>
        <p className={styles.text}>
          Free trials will automatically convert to a paid subscription unless canceled at least 3 days prior to the end of the trial.
        </p>
      </section>

      {/* 3. Auto-Renewal Subscriptions */}
      <section className={styles.section}>
        <h2 className={styles.sectionTitle}>3. Auto-Renewal Subscriptions</h2>
        <p className={styles.text}>
          To avoid automatic renewal, cancel at least 3 days before the next billing date through your account or by emailing <a href="mailto:support@sageion.com">support@sageion.com</a>.
        </p>
      </section>

      {/* 4. Refund Policy */}
      <section className={styles.section}>
        <h2 className={styles.sectionTitle}>4. Refund Policy</h2>
        <p className={styles.text}>
          Refunds are not provided for canceled subscriptions, except when Sageion.com terminates the subscription for convenience or due to technical reasons.
        </p>
      </section>

      {/* 5. Late Payments */}
      <section className={styles.section}>
        <h2 className={styles.sectionTitle}>5. Late Payments</h2>
        <p className={styles.text}>
          You are responsible for any rejected payments. Sageion.com may charge interest on overdue balances at 1.5% per month or the maximum permitted by law.
        </p>
      </section>

      <footer className={styles.footer}>
        <p className={styles.footerText}>
          Last updated: October 13, 2025. For inquiries, contact us at <a href="mailto:support@sageion.com">support@sageion.com</a>.
        </p>
      </footer>
    </div>
  );
};

export default CancellationRefundPolicy;
